var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.25C12 4.72501 11.3942 3.26247 10.3159 2.18414C9.23753 1.1058 7.77499 0.5 6.25 0.5M12 6.25H0.5M12 6.25C12 7.77499 11.3942 9.23753 10.3159 10.3159C9.23753 11.3942 7.77499 12 6.25 12M6.25 0.5C4.72501 0.5 3.26247 1.1058 2.18414 2.18414C1.1058 3.26247 0.5 4.72501 0.5 6.25M6.25 0.5C5.93919 0.5 3.76351 3.07413 3.76351 6.25C3.76351 9.42586 5.93919 12 6.25 12M6.25 0.5C6.56081 0.5 8.73649 3.07413 8.73649 6.25C8.73649 9.42586 6.56081 12 6.25 12M0.5 6.25C0.5 7.77499 1.1058 9.23753 2.18414 10.3159C3.26247 11.3942 4.72501 12 6.25 12",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ce06e5bd8582ee22437b109e879ab9f8.svg";
export { ForwardRef as ReactComponent };